import controllerReducer from "./slices/controllerSlice";
import videoDataReducer from "./slices/videoDataSlice";
import popoversReducer from "./slices/popoversSlice";
import commentsReducer from "./slices/commentsSlice";
import chatReducer from "./slices/chatSlice";
import tagsReducer from "./slices/tagsSlice";
import userReducer from "./slices/userSlice";
import quizReducer from "./slices/quizSlice";

import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
    reducer: {
        controller: controllerReducer,
        videoData: videoDataReducer,
        popovers: popoversReducer,
        comments: commentsReducer,
        chats: chatReducer,
        user: userReducer,
        tags: tagsReducer,
        quiz: quizReducer
    },
    devTools: true,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
